export default {
	'CMB_DSP_TOKEN_API_URL': process.env.REACT_APP_DSP_TOKEN_URL,
	'CMB_DSP_TOKEN_API_CLIENT_ID': process.env.REACT_APP_DSP_TOKEN_CLIENT,
	'CMB_DSP_TOKEN_API_CLIENT_SECRET': process.env.REACT_APP_DSP_TOKEN_SECRET,
	'timeout': 60000
};
